export default "__VITE_ASSET__2b534a52__"